export enum StorageKeys {
	GOAL_SETTING_DATA = "goalSettingData",
	QUESTION_DATA = "questionData",
	TASK_DATA = "taskData",
	ROUTE_ID = "routeId",
	AUTH_DATA = "__auth-data",
	DUMMY_TOTAL_COMPANIES = "totalCompanies",
	DAILY_MISSION = "dailyMission",
	FEATURE_CONFIG = "featureConfig",
	COMPANY_URLS = "companyUrls",
	JOURNEYMAP_SELECTED = "journeyMapSelected",
	JOURNEYMAP_LIST = "journeyMapList",
	JOURNEYMAP_MAPPED = "journeyMapMapped",
}
